import { lazyWithPreload as lazy } from 'react-lazy-with-preload';

const DirectSalesLanding = {
  Content: lazy(
    () =>
      import('components/direct-sales-landing/components/DirectSalesContent')
  ),
  RightSidebar: lazy(
    () =>
      import(
        'components/direct-sales-landing/components/DirectSalesSidebarRight'
      )
  ),
  Header: lazy(
    () => import('components/direct-sales-landing/components/DirectSalesHeader')
  ),
  Footer: lazy(
    () => import('components/direct-sales-landing/components/DirectSalesFooter')
  )
};

export default DirectSalesLanding;
